import { render, staticRenderFns } from "./modal-incidente-otros.vue?vue&type=template&id=e0f0bc98&"
import script from "./modal-incidente-otros.vue?vue&type=script&lang=js&"
export * from "./modal-incidente-otros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports